<template>
    <v-container
            fluid
    >
        <v-row
                align="center"
                justify="center"
                class="text-center">
            <v-col
                    cols="12"
                    md="5"
            >
                <v-img
                        class="ml-4 mr-4"
                        :src="language === 'es' ? require('../../assets/logo_escuela.png') : require('../../assets/logo_escuela.png')"
                        height="250px"
                        contain
                ></v-img>
                <br>
                <h3>{{$t('msg_password_reset')}}</h3>
                <v-form
                        class="mb-4"
                        @submit.prevent="resetPassword()">
                    <v-flex xs12>
                        <v-text-field
                                v-model="email"
                                prepend-icon="mdi-email"
                                name="email"
                                label="E-Mail"
                                :error-messages="errores.error"
                                outlined
                        >
                        </v-text-field>
                    </v-flex>
                    <v-btn
                            color="primary"
                            type="submit"
                            :loading="loading">
                        {{$t('enviar')}}
                    </v-btn>
                </v-form>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import {HTTP} from '@/main.js'
import { mapState } from 'vuex'

export default {
  name: 'password_reset',
  data: () => ({
    email: '',
    errores: [],
    loading: false
  }),
  computed: {
    ...mapState(['language'])
  },
  methods: {
    resetPassword: function () {
      this.loading = true
      this.errores = []
      HTTP.patch('users/reset_password/', {
        email: this.email
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(ok => {
        console.log(ok)
        this.loading = false
        this.$router.push({ path: '/password_reset_done' })
      })
      .catch(error => {
        this.loading = false
        if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
          this.errores = error.response.data
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
